import emitter, { AppEvents } from './events'

export const ToastTypeEnum = {
	Success: 'success',
	Error: 'error',
	Info: 'info',
}

export const useToast = () => {
	const showToast = (type, message, timeout) => {
		emitter.emit(AppEvents.ShowToast, {
			message,
			type,
			timeout,
		})

		if (timeout == null) return Promise.resolve()

		return new Promise(resolve => {
			const tid = setTimeout(() => {
				resolve()
				clearTimeout(tid)
			}, timeout)
		})
	}
	return {
		showSuccessToast: (message, timeout = null) =>
			showToast(ToastTypeEnum.Success, message, timeout),

		showErrorToast: (message, timeout = null) =>
			showToast(ToastTypeEnum.Error, message, timeout),

		showInfoToast: (message, timeout = null) =>
			showToast(ToastTypeEnum.Info, message, timeout),

	}
}
